import Enum from '@square/dashboard-utilities/utils/enum';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export const ProductLabelTemplateProvider = new Enum(['AVERY', 'DYMO', 'ZEBRA']);
export default ProtoBaseModel.extend({
  name: attr(String),
  token: attr(String),
  provider: attr(ProductLabelTemplateProvider),
  restrictConfiguration: attr(Boolean),
  isDeprecated: attr(Boolean)
});